import Image from "gatsby-plugin-sanity-image";
import CollegeOfLiberalArtsHeader from "../components/college-of-liberal-arts/header";
import SanityVideoPlayer from "../components/SanityVideoPlayer";
import GenericHeader from "./shared/generic-header";

function BackgroundWrapper(props) {
  function hasVideoBackground() {
    return (
      props.pageHeader?.videoMp4?.asset?.url ||
      props.pageHeader?.videoWebm?.asset?.url
    );
  }
  function hasImageBackground() {
    return props?.image?.asset;
  }

  if (hasVideoBackground()) {
    return (
      <section className="relative flex items-center justify-center overflow-hidden">
        <div className="bg-transparent flex z-20 pt-48 pb-40 min-w-full max-w-none">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-wrap items-start px-4">
              <div className="w-full md:w-8/12 text-white">
                <hr className="w-8 border-yellow-500 border-4 mb-2" />
                <h1 className="font-bold tracking-tighter text-3xl md:text-6xl mb-6">
                  {props.pageHeader.title}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute z-10 w-auto min-w-full min-h-full max-w-none mobile-fallback" />
        <SanityVideoPlayer {...props.pageHeader} />
      </section>
    );
  }

  if (hasImageBackground()) {
    return (
      <div
        className={`bg-transparent${
          props.section?.sectionSlug?.current === "campaign"
            ? ` bg-transparent--campaign`
            : ``
        } ${
          props.isTitleCase ? `py-20 md:py-32` : "pb-6 pt-36 md:pt-64 md:pb-24"
        }`}
      >
        <Image
          {...props.image}
          width={1920}
          className="bg-transparent__image"
          alt={""}
        />
        <div className="bg-transparent__content">
          <div
            className={`${
              props.isTitleCase ? `max-w-6xl` : `max-w-7xl`
            } mx-auto px-4`}
          >
            {props.children}
          </div>
        </div>
      </div>
    );
  }

  const themeMap = new Map();
  themeMap.set("CascadeLayout", GenericHeader);
  themeMap.set("CampaignLayout", GenericHeader);
  themeMap.set("RollinsLayout", CollegeOfLiberalArtsHeader);
  themeMap.set("GraduateStudiesLayout", CollegeOfLiberalArtsHeader);
  themeMap.set("ContinuingStudiesLayout", CollegeOfLiberalArtsHeader);

  const HeaderComponent =
    props?.section?.theme && themeMap.get(props.section.theme.themeComponent)
      ? themeMap.get(props.section.theme.themeComponent)
      : GenericHeader;

  return (
    <HeaderComponent
      section={props.section}
      title={props.pageHeader ? props.pageHeader.title : "N/A"}
    >
      {props.children}
    </HeaderComponent>
  );
}

export default BackgroundWrapper;
